export const ReputationManagementConstants = {
    REPUTATION_MANAGEMENT_LIST_PENDING: 'REPUTATION_MANAGEMENT_LIST_PENDING',
    REPUTATION_MANAGEMENT_LIST_FULFILLED: 'REPUTATION_MANAGEMENT_LIST_FULFILLED',
    REPUTATION_MANAGEMENT_LIST_REJECTED: 'REPUTATION_MANAGEMENT_LIST_REJECTED',
    REPUTATION_MANAGEMENT_LIST_CLEAR: 'REPUTATION_MANAGEMENT_LIST_CLEAR',

    REPUTATION_MANAGEMENT_SYNC_PENDING: 'REPUTATION_MANAGEMENT_SYNC_PENDING',
    REPUTATION_MANAGEMENT_SYNC_FULFILLED: 'REPUTATION_MANAGEMENT_SYNC_FULFILLED',
    REPUTATION_MANAGEMENT_SYNC_REJECTED: 'REPUTATION_MANAGEMENT_SYNC_REJECTED',
    REPUTATION_MANAGEMENT_SYNC_CLEAR: 'REPUTATION_MANAGEMENT_SYNC_CLEAR',

    REPUTATION_MANAGEMENT_REVIEW_PENDING: 'REPUTATION_MANAGEMENT_REVIEW_PENDING',
    REPUTATION_MANAGEMENT_REVIEW_FULFILLED: 'REPUTATION_MANAGEMENT_REVIEW_FULFILLED',
    REPUTATION_MANAGEMENT_REVIEW_REJECTED: 'REPUTATION_MANAGEMENT_REVIEW_REJECTED',
    REPUTATION_MANAGEMENT_REVIEW_CLEAR: 'REPUTATION_MANAGEMENT_REVIEW_CLEAR',

    REPUTATION_MANAGEMENT_REVIEW_STATISTICS_PENDING: 'REPUTATION_MANAGEMENT_REVIEW_STATISTICS_PENDING',
    REPUTATION_MANAGEMENT_REVIEW_STATISTICS_FULFILLED: 'REPUTATION_MANAGEMENT_REVIEW_STATISTICS_FULFILLED',
    REPUTATION_MANAGEMENT_REVIEW_STATISTICS_REJECTED: 'REPUTATION_MANAGEMENT_REVIEW_STATISTICS_REJECTED',
    REPUTATION_MANAGEMENT_REVIEW_STATISTICS_CLEAR: 'REPUTATION_MANAGEMENT_REVIEW_STATISTICS_CLEAR',
};
